import axios from 'axios';
// import AV from 'leancloud-storage'
import {BASE_URL} from '../config/config'
let baseURL = BASE_URL
// let baseURL = 'https://stg-lcen.xiaote.net'
axios.defaults.timeout = 90000;
// axios.defaults.baseURL ='https://stg-lcen.xiaote.net'; //填写域名

//http request 拦截器
axios.interceptors.request.use(
  config => {
    config.data = JSON.stringify(config.data);
    config.headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      'X-LC-Id': '4Paj7MSbcOPWbUj4qLbPdm4B-gzGzoHsz',
      'X-LC-Key': 'cTBgegHXVcwPhAl4CTcMcMwm',
      'app-platform': 'web',
      'app-version': '0.0.1',
      'X-App-Secret': '9s6XzoDJ27HxHQ7M'
    }
    let sessionToken = localStorage.sessionToken
    if (sessionToken) {
      config.headers['X-LC-Session'] = sessionToken
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
)

//响应拦截器即异常处理
axios.interceptors.response.use(response => {
    return response
}, err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
            console.log('错误请求')
          break;
        case 401:
            console.log('未授权，请重新登录')
          break;
        case 403:
          console.log('拒绝访问')
          break;
        case 404:
          console.log('请求错误,未找到该资源')
          break;
        case 405:
          console.log('请求方法未允许')
          break;
        case 408:
          console.log('请求超时')
          break;
        case 500:
          console.log('服务器端出错')
          break;
        case 501:
          console.log('网络未实现')
          break;
        case 502:
          console.log('网络错误')
          break;
        case 503:
          console.log('服务不可用')
          break;
        case 504:
          console.log('网络超时')
          break;
        case 505:
          console.log('http版本不支持该请求')
          break;
        default:
          console.log(`连接错误${err.response.status}`)
      }
    } else {
      console.log('连接到服务器失败')
    }
    return Promise.resolve(err.response)
})


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export const get = (url, params = {}, ip = '') => {
  url = ip ? `${ip}${url}` : `${baseURL}${url}`
  return new Promise((resolve,reject) => {
    axios.get(url, {params}).then(response => {
      console.log(response)
      resolve(response.data)
    }).catch(err => {
      reject(err)
    })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

 export const post = (url, data = {}, ip = '') => {
  url = ip ? `${ip}${url}` : `${baseURL}${url}`
  return new Promise((resolve,reject) => {
    axios.post(url, data).then(response => {
      console.log(url, data)
      resolve(response.data);
    }, err => {
      reject(err)
    })
  })
 }

 /**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export const patch = (url, data = {}, ip = '') => {
  url = ip ? `${ip}${url}` : `${baseURL}${url}`
  return new Promise((resolve,reject) => {
    axios.patch(url, data).then(response => {
      resolve(response.data);
    }, err => {
      reject(err)
    })
  })
}

 /**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export const put = (url, data = {}, ip = '') => {
  url = ip ? `${ip}${url}` : `${baseURL}${url}`
  return new Promise((resolve,reject) => {
    axios.put(url, data).then(response => {
      resolve(response.data);
    }, err => {
      reject(err)
    })
  })
}

 /**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export const del = (url, data = {}, ip = '') => {
  url = ip ? `${ip}${url}` : `${baseURL}${url}`
  return new Promise((resolve,reject) => {
    console.log(data)
    axios.delete(url, {data}).then(response => {
      resolve(response.data)
    }, err => {
      reject(err)
    })
  })
}


// WEBPACK FOOTER //
// ./src/http/axios.js